import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const PlayFill = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='PlayFill' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M3,22.0000002 L21,12 L3,2 L3,22.0000002 Z M5,19 L17.5999998,11.9999999 L5,5 L5,19 Z M7,16 L14.1999999,12 L7,8 L7,16 Z M9,13 L10.8,12 L9,11 L9,13 Z' />
  </StyledIcon>
);
